import { useMemo } from 'react';

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// react-chartjs-2 components
import { Bar } from 'react-chartjs-2';

// @mui material components
import Card from '@mui/material/Card';

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';

// HorizontalBarChart configurations
import configs from 'prefabsComponents/Charts/BarCharts/HorizontalBarChart/configs';

// Soft UI Dashboard PRO React base styles
import colors from 'assets/theme/base/colors';

import SoftButton from 'components/SoftButton';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

function HorizontalBarChart({ title, description, height, chart }) {
    const chartDatasets = chart.datasets
        ? chart.datasets.map(dataset => ({
              ...dataset,
              weight: 5,
              borderWidth: 0,
              borderRadius: 4,
              backgroundColor: colors[dataset.color]
                  ? colors[dataset.color || 'dark'].main
                  : colors.dark.main,
              fill: false,
              maxBarThickness: 35,
          }))
        : [];

    const { data, options } = configs(chart.labels || [], chartDatasets);

    const renderChart = (
        <SoftBox p={2}>
            {title || description ? (
                <SoftBox px={description ? 1 : 0} pt={description ? 1 : 0}>
                    {title && (
                        <SoftBox
                            mb={1}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <SoftTypography variant="h6">
                                {title}
                            </SoftTypography>
                            <SoftButton variant="outlined" color="dark">
                                <CloudDownloadIcon />
                                &nbsp;Descargar
                            </SoftButton>
                        </SoftBox>
                    )}
                    {description && (
                        <SoftBox mb={2}>
                            <SoftTypography
                                component="div"
                                variant="button"
                                fontWeight="regular"
                                color="text"
                            >
                                {description}
                            </SoftTypography>
                        </SoftBox>
                    )}
                </SoftBox>
            ) : null}
            {useMemo(
                () => (
                    <SoftBox height={height}>
                        <Bar data={data} options={options} />
                    </SoftBox>
                ),
                [chart, height]
            )}
        </SoftBox>
    );

    return title || description ? <Card>{renderChart}</Card> : renderChart;
}

// Setting default values for the props of HorizontalBarChart
HorizontalBarChart.defaultProps = {
    title: '',
    description: '',
    height: '19.125rem',
};

// Typechecking props for the HorizontalBarChart
HorizontalBarChart.propTypes = {
    title: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    chart: PropTypes.objectOf(PropTypes.array).isRequired,
};

export default HorizontalBarChart;
